// eslint-disable-next-line no-restricted-imports
import { enableMapSet } from 'immer';

enableMapSet();

// eslint-disable-next-line no-restricted-imports
export * from 'immer';
